import Cookies from 'js-cookie';
import helperMatomo from 'shared/mixins/helper-matomo';
import helperGoogle  from 'shared/mixins/helper-google';

/**
 * @module
 */

const eltAttr = "data-js-forms-form-element";
const selector = "[" + eltAttr + "]";
const form = function (el, app) {

    const $el = $(el);
    const formEltId = $el.attr(eltAttr)
    const navItemId = $el.attr("data-forms-form-navitem")
    const $form = $el.find("form")
    const $submit = $form.find("button[type=submit]")
    const $fields = $form.find("[data-forms-form-field]")
    const $formSetAdd = $form.find("[data-js-forms-form-set-add]")
    const $formSetRemove = $form.find("[data-js-forms-form-set-remove]")
    const $sending = $el.find(".Ge-Form-Sending")
    const $save = $el.find('[data-js-forms-save]')

    const matomo = helperMatomo(app);
    const google = helperGoogle(app);

    const init = function () {
        registerEvents();
    };


    const show = function (...$elts) {
        for (var i = 0; i < $elts.length; i++) {
            $elts[i].removeClass("Ge-Hidden");
        }
    };

    const hide = function (...$elts) {
        for (var i = 0; i < $elts.length; i++) {
            $elts[i].addClass("Ge-Hidden");
        }
    };

    const registerEvents = function () {

        $save.click( save )

        $submit.click(ev => {
            ev.stopPropagation();
            ev.preventDefault();
            $form.trigger('formValidate', { submit: submit })
        });
        $formSetAdd.click(function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            const $button = $(this);
            const $set = $button.closest(".Ge-Form-Set");
            show($set.next(".Ge-Form-Set"));
            hide($button.closest(".Ge-Btn-Bar"));
            $el.trigger("formSetDisplayChange");
        });

        $formSetRemove.click(function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            const $set = $(this).closest(".Ge-Form-Set");
            show($set.prev(".Ge-Form-Set").find("[data-js-forms-form-set-add]").closest(".Ge-Btn-Bar"));
            hide($set);
            $el.trigger("formSetDisplayChange");
        });

    };

    const getValues = function ($field) {
        switch ($field.attr("data-forms-form-field-type")) {
            case "file-input":
                return [];
            case "text-input":
                return [$field.find(".Ge-Input").val()];
            case "select":
                return [$field.find(".Ge-Select").val()];
            case "radio": {
                var rs = [];
                $.each($field.find(".Ge-Radio"), function () {
                    var $r = $(this);
                    if ($r.prop("checked")) {
                        rs.push($r.val());
                    }
                });
                return rs;
            }
            case "checkbox": {
                var cbs = [];
                $.each($field.find(".Ge-Checkbox"), function () {
                    var $cb = $(this);
                    if ($cb.prop("checked")) {
                        cbs.push($cb.val());
                    }
                });
                return cbs;
            }

        }

        return [];
    };

    const getFile = function getFile($field) {

        switch ($field.attr("data-forms-form-field-type")) {
            case "file-input":
                var $fields = $field.find(".Ge-Input");
                var files = $fields[0].files;
                if (files.length === 0) {
                    return null;
                }

                return files[0];
        }
        return null;
    };

    const uploadFiles = function (files) {

        if (files.length === 0) {
            return $.Deferred().resolve([]);
        }

        return Dx.Ui.Util.upload({ files: files });
    }

    const checkValid = function (fields) {

        var isOk = true;
        for (var i = 0; i < fields.length; i++) {
            var f = fields[i];
            if (f.isRequired) {
                var $inp = $("[data-forms-form-field=" + f.fieldId + "] input");

                if (f.values.length === 0) {
                    $inp.attr('aria-invalid', "true"); // TODO: Trigger custm event (can't be done until better jquery include handling)
                    isOk = false;
                }
                else {
                    $inp.attr('aria-invalid', "false");
                }
            }
        }

        return isOk;
    }

    const collectData = () => {

        var fields = [];
        var files = [];

        $fields.each((_, x) => {

            var $field = $(x);

            if (!$field.is(":visible")) {
                return;
            }

            var fieldId = $field.attr("data-forms-form-field");
            var matomoParameter = $field.attr("data-forms-form-field-matomo");

            var values = getValues($field);
            var file = getFile($field);
            var cookieName = $field.attr("data-forms-form-field-cookie");

            if (cookieName) {
                Cookies.set(cookieName, values);
            }

            if (file !== null) {
                files.push(file);
            }
            var field = {
                "fieldId": fieldId,
                "values": values,
                "files": file === null ? null : [],
                "matomo": matomoParameter
            };

            fields.push(field);
        });

        $sending.removeClass("Ge-Hidden");

        return uploadFiles(files).then(ufs => {

            var fieldIndex = 0;
            for (var i = 0; i < ufs.length; i++) {

                var field;
                var found = false;
                do {
                    field = fields[fieldIndex];
                    if (field.files === null) {
                        field.files = [];
                    }
                    else {
                        field.files.push(ufs[i]);
                        found = true;
                    }
                    fieldIndex++;
                } while (!found);

            }

            // Clear remaining file-fields
            while (fieldIndex < fields.length) {
                fields[fieldIndex].files = [];
                fieldIndex++;
            }

            var data = {
                "formId": formEltId,
                "navItemId": navItemId,
                "fields": fields
            }

            return data
        })

    }

    const signalPopup = function ( info ) {
        window.dispatchEvent(new CustomEvent( 'SaveFormModal', info ));
    }

    const save = function( ev ) {
        
        ev.preventDefault();
        ev.stopPropagation();

        signalPopup( { event: 'start' } )
        
        collectData().then( data => {
            $.post("/GeneralApi", { "command": "SaveForm", "data": JSON.stringify(data) })
            .then ( r => {
                $sending.addClass("Ge-Hidden");
                signalPopup( {event: 'saved', url: r.result.url } )
            });
        });
    }

    const track = function(r, data) {

        let isResolved = false;
        
        if (showDebug) {
            console.log( "Tracking");
        }

        let promise = new Promise( function( resolve ) {

            const internalResolve = () => {
                if( !isResolved ){
                    if (showDebug) {
                        console.log( "Resolving");
                    }
    
                    isResolved = true;
                    resolve(r);
                }
                else {
                    if (showDebug) {
                        console.log( "Already resolved");
                    }

                }
            }

            if( r.result.action === "error"){
                internalResolve();
                // resolve(r);
            }
            const matomoEvent =$el.attr('data-js-matomo-event');
            if( matomoEvent ) {
                if (showDebug) {
                    console.log( "Tracking matomo");
                }
                const matomoEventObj = JSON.parse(matomoEvent);
                for( let f=0;f<data.fields.length;f++){
                    const field = data.fields[f];
                    if( field.matomo ){
                        matomoEventObj[field.matomo] = field.values.join( "," );
                    }
                }
                matomo.push( matomoEventObj );
            }
            const googleEvent =$el.attr('data-js-google-event');
            if( googleEvent ) {

                google.gtag( JSON.parse(googleEvent), function(id) {
                     if (showDebug) {
                         console.log( "google complete: " + id);
                     }
                     setTimeout( internalResolve, 1000 );
                } );
            }

            if( matomoEvent || googleEvent ){
                setTimeout( () => {
                    if (showDebug) {
                        console.log( "Resolving after timeout");
                    }
                    internalResolve()
                }, 5000 );
            }
            else {
                internalResolve();
            }
        });

        return promise;
    }

    const submit = function (ev) {

        $submit.prop( "disabled", true );

        collectData().then( data => {
            $.post("/GeneralApi", { "command": "SubmitForm", "data": JSON.stringify(data) })
            .then(r => {
                if( showDebug ){
                    console.log( JSON.stringify(r) )
                }
                return track( r, data )
             } )
            .then( r => {
                if( showDebug ){
                    console.log( JSON.stringify(r) )
                }
                $sending.addClass("Ge-Hidden");
                // if( r.result.action !== "error" ){
                //     const matomoEvent =$el.attr('data-js-matomo-event');
                //     if( matomoEvent ) {
                //         const matomoEventObj = JSON.parse(matomoEvent);
                //         for( let f=0;f<data.fields.length;f++){
                //             const field = data.fields[f];
                //             if( field.matomo ){
                //                 matomoEventObj[field.matomo] = field.values.join( "," );
                //             }
                //         }
                //         matomo.push( matomoEventObj );
                //     }
                //     const googleEvent =$el.attr('data-js-google-event');
                //     if( googleEvent ) {
                //         google.gtag( JSON.parse(googleEvent),  );
                //     }
                // }
                switch (r.result.action) {
                    case "navigate":
                        window.location.href = r.result.url;
                        break;
                    case "top-message":
                        if (r.result.hideForm) {
                            $form.remove();
                        }
                        app.trigger('msgGlobal', [r.result.message, "form" + formEltId, 'ok', false, false]);
                        break;
                    case "message":
                        if (r.result.hideForm) {
                            $form.remove();
                        }
                        $el.find(".Ge-Form-OkMessage").removeClass("Ge-Hidden");
                        break;

                    case "error":
                        $submit.prop( "disabled", false );
                        $el.find(".Ge-Form-OkMessage").addClass("Ge-Hidden");
                        $el.find(".Ge-Form-ErrorMessage").removeClass("Ge-Hidden");
                        break;
                }
            });
        });

        return;

    };

    return {
        init: init()
    };
};

form.selector = selector;

export default form;
